// The file policy of a deal's documents (TX-US-0031, TX-US-0043): PDF, JPEG and PNG, the two
// Office formats working papers arrive in, and a saved email - the thread a deal was agreed in. It
// mirrors ALLOWED_CONTENT_TYPES in trex/documents/service.py; the API is the authority.
//
// The delivery tracker's attachments keep the narrower policy in files.js.

import { ALLOWED_CONTENT_TYPES, MAX_UPLOAD_BYTES } from './files.js';

// By extension, because a browser on a machine without Office reports no type for these.
const OFFICE_TYPES = Object.freeze({
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
});

// By extension, always: browsers report a .msg as Outlook's type, as a generic binary or as
// nothing, and the API takes only the one.
const EMAIL_TYPES = Object.freeze({
  eml: 'message/rfc822',
  msg: 'application/vnd.ms-outlook',
});

export const DEAL_CONTENT_TYPES = Object.freeze([
  ...ALLOWED_CONTENT_TYPES,
  ...Object.values(OFFICE_TYPES),
  ...Object.values(EMAIL_TYPES),
]);

// What the file input offers: the types, and the extensions for a browser that knows only those.
export const ACCEPT = [...DEAL_CONTENT_TYPES, '.xlsx', '.docx', '.eml', '.msg'].join(',');

export const FORMATS_HINT = 'PDF, Excel, Word, JPEG, PNG or a saved email · up to 25 MB each';

const extension = (name) => name.slice(name.lastIndexOf('.') + 1).toLowerCase();

// The type the upload is requested and stored under: a saved email's by its extension, otherwise
// the browser's, or the extension's when the browser has none to give.
export const contentTypeOf = (file) => EMAIL_TYPES[extension(file.name)]
  ?? (file.type || OFFICE_TYPES[extension(file.name)] || '');

export function validateDealFile(file) {
  if (!DEAL_CONTENT_TYPES.includes(contentTypeOf(file))) {
    return 'Only PDF, Excel (.xlsx), Word (.docx), JPEG, PNG and saved emails (.eml, .msg) are supported.';
  }
  if (file.size <= 0) return 'The selected file is empty.';
  if (file.size > MAX_UPLOAD_BYTES) return 'The selected file is larger than 25 MB.';
  return null;
}
